<script lang="ts">
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";

</script>

<FizzStyles>
  <div
    class="fizz-layout-primary fizz-center-content fizz-inset-vertical-48"
    class:fizz-inset-square-16={$LayoutStore.isMobile}
  >
    <div
      class="fizz-card fizz-bordered fizz-inset-square-24"
      class:fizz-half-width={$LayoutStore.isDesktop}
    >
      <div class="fizz-center-content fizz-flow-16">
        <Icon type="Error" color="#002B48" height="48" width="48" />
        <h4 class="fizz-heading-4 fizz-text-center">
          There was an error submitting your application.
        </h4>
        <p class="fizz-text-center">
          Please contact <a href="mailto:support@provi.com">support@provi.com</a> for assistance.
        </p>
      </div>
    </div>
  </div>
</FizzStyles>
